import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "./ui/button";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { name: "Home", id: "home" },
    { name: "Rooms", id: "rooms" },
    { name: "Gallery", id: "gallery" },
    { name: "Contact", id: "contact" },
  ];

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        isScrolled
          ? "backdrop-blur-xl bg-white/80 shadow-md py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        {/* LOGO */}
        <button onClick={() => scrollToSection("home")} className="group">
          <h1
            className={`text-xl md:text-2xl font-semibold tracking-tight transition-all duration-300 ${
              isScrolled ? "text-gray-900" : "text-white"
            } group-hover:text-[#d4a373]`}
          >
            Jungle Villa
          </h1>
          <p
            className={`text-[10px] tracking-[0.3em] uppercase transition ${
              isScrolled ? "text-gray-600" : "text-white/70"
            }`}
          >
            Mount Abu
          </p>
        </button>

        {/* DESKTOP NAV */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className={`relative text-sm uppercase tracking-wider transition-all duration-300 ${
                isScrolled ? "text-gray-800" : "text-white"
              }`}
            >
              {link.name}

              {/* underline animation */}
              <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-[#d4a373] transition-all duration-300 group-hover:w-full"></span>

              {/* glow effect */}
              <span className="absolute inset-0 opacity-0 hover:opacity-100 transition duration-300 blur-md bg-[#d4a373]/20"></span>
            </button>
          ))}

          {/* CTA BUTTON */}
          <Button
            onClick={() => window.open("tel:+919256930540")}
            className={`relative px-6 py-2 rounded-full text-sm flex items-center gap-2 overflow-hidden transition-all duration-300 ${
              isScrolled
                ? "bg-black text-white hover:bg-[#d4a373] hover:text-black"
                : "bg-white/20 backdrop-blur-md text-white border border-white/30"
            }`}
          >
            {/* glow */}
            <span className="absolute inset-0 bg-[#d4a373]/20 blur-lg opacity-0 hover:opacity-100 transition"></span>
            <Phone className="w-4 h-4" />
            Book Now
          </Button>
        </div>

        {/* MOBILE BUTTON */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`md:hidden ${isScrolled ? "text-black" : "text-white"}`}
        >
          {isMobileMenuOpen ? <X /> : <Menu />}
        </button>
      </div>

      {/* MOBILE MENU */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg mt-2 px-6 py-6 space-y-4">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="block w-full text-left text-gray-800 hover:text-[#d4a373] transition"
            >
              {link.name}
            </button>
          ))}

          <button
            onClick={() => window.open("tel:+919256930540")}
            className="w-full bg-black text-white py-2 rounded-full hover:bg-[#d4a373] hover:text-black transition"
          >
            Book Now
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
